export const HE_LOCALES = {
  ACCEPT_COOKIES: 'לקבל עוגיות',
  ADDED: 'נוסף',
  ADD_ITEM: 'הוספת פריט',
  ADD_SERVICES_TO_ORDER: 'תוסיף שירותים להזמנתך',
  ADD_TO_ORDER: 'הוסף להזמנה',
  AFTERCARE_SERVICES: 'שירותי טיפול בקבר',
  ASK_YOUR_QUESTION: 'הזן את השאלה ואנו ניצור אתך קשר בהקדם האפשרי',
  BACK: 'לחזור אחורה',
  BACK_TO_HOME_PAGE: 'חזרה לעמוד הראשי',
  BACK_TO_MAIN_PAGE: 'חזרה לעמוד הראשי',
  BACK_TO_RECORD_PAGE: 'לחזור לעמוד הרישום',
  BLOCK: 'שורה',
  CANCEL: 'בטל',
  CART_EMPTY: 'העגלה ריקה',
  CEMETERY: 'בית עלמין',
  CHECKOUT: 'להזמנה',
  CHECK_ORDER_DETAILS: 'פרטי ההזמנה ופרטי הלקוח',
  CLOSE_CART: 'לסגור עגלה',
  CLOSE_GALLERY: 'סגור את הגלריה',
  CONTACT_CEMETERY: 'להגיש את הבקשה שלך',
  COPIED: 'הועתק',
  COPY_URL: 'העתק קישור',
  DECEDENT: 'שם המנוח',
  DISMISS: 'לשחרר',
  DOWNLOAD_FREE_MOBILE_APP: 'הורד את האפליקציה בחינם לנייד',
  EACH: 'כל אחד',
  EMAIL: 'אימייל',
  EMAIL_FORMAT: 'פורמט דוא"ל לא תקין (user@example.com)',
  ENTER_CARD_INFO: 'נא להקליד מידע על כרטיס אשראי',
  FACEBOOK: 'פייסבוק',
  FIND_LOCATION: 'פרטים על מקום  הקבורה',
  FIRST_NAME: 'שם פרטי',
  FIRST_NAME_MIN_LENGTH: 'שם פרטי קצר מדי (לפחות 2 תווים)',
  GO_TO_PAYMENT: 'עבור לתשלום',
  GO_TO_X_PAGE: '{X} עבור לדף',
  IF_YOU_HAVE_QUESTION:
    'נא ליצור איתנו קשר לגבי שירותים שונים או שירות שאינו מופיע ברשימה וננסה לעזור לכם.',
  INDEX_PAGE: 'אינדקס',
  LAST_NAME: 'שם משפחה',
  LAST_NAME_MIN_LENGTH: 'שם משפחה קצר מדי (לפחות 2 תווים)',
  LOCATION: 'מיקום',
  LOGO: 'סמל',
  MAKE_PAYMENT: 'ביצוע תשלום',
  MESSAGE_MIN_LENGTH: 'ההודעה קצרה מדי (לפחות 5 תווים)',
  MOVE: 'מַהֲלָך',
  NAME_MIN_LENGTH: 'השם קצר מדי (לפחות 2 תווים)',
  NEXT: 'הבא',
  NO: 'לא',
  ON_OUR_WEBSITE_WE_USE_COOKIE:
    'באתר שלנו אנו משתמשים בעוגיות טכניות, אנליטיות, שיווקיות והעדפות. אלה נחוצים כדי שהאתר שלנו יפעל כראוי וכדי לתת לנו מידע על אופן השימוש באתר שלנו.',
  OPEN_CART: 'לפתוח עגלה',
  ORDER_CREATED: 'ההזמנה נוצרה',
  ORDER_DETAILS_WILL_BE_SENT: 'פרטי ההזמנה יישלחו לכתובת הדואר האלקטרונית שציינת',
  ORDER_NUMBER: 'מספר הזמנה',
  ORDER_TOTAL: "סה''כ להזמנה",
  PAGE_LINK_HAS_BEEN_COPIED: 'הקישור לעמוד הועתק ללוח',
  PAYMENT: 'תשלום',
  PAYMENT_ERROR: 'שגיאה בתשלום',
  PAYMENT_FORM_EXPIRED: 'טופס התשלום פג תוקף',
  PER: 'עבור',
  PHONE_FORMAT: 'פירמוט טלפון לא תקין',
  PHONE_NUMBER: 'טלפון / whatsapp',
  PHOTO: 'תמונה',
  PLACE_ORDER: 'בצע הזמנה',
  PLACEMENT: 'הצבה',
  PLEASE_TRY_AGAIN_LATER: 'אנא נסה שוב מאוחר יותר',
  PLOT: 'מקום',
  PREVIOUS: 'הקודם',
  PRIVACY_POLICY: 'מדיניות פרטיות ותנאי השימוש',
  PURCHASER: 'פרטי הלקוח',
  RECEIVE_REPORT_BY_EMAIL: 'תקבל/י הודעה על השלמת העבודה ותמונות הדיווח דרך הדואר האלקטרוני',
  REJECT: 'לדחות עוגיות',
  RELOAD_PAGE: 'טען מחדש את הדף',
  REMOVE_FROM_CART: 'להסיר מהעגלה?',
  REMOVE_ITEM: 'הסרת פריט',
  RESTORATION_TOMBSTONE: 'חידוש מצבה',
  REQUIRED_DATA: 'שדה חובה',
  REQUIRED_FIELDS_MISSING: 'חסר מידע בכמה שדות חובה',
  SEARCH: 'חיפוש',
  SEARCH_BURIAL_RECORDS: 'חיפוש ברשומות הקבורה, בזיכרון',
  SECTION: 'חלקה',
  SEE_EXAMPLES: 'ראה דוגמאות',
  SERVICES: 'חידוש מצבה',
  SOMETHING_WENT_WRONG: 'משהו השתבש',
  SHARE: 'שתף',
  SHARE_ORDER: 'שיתוף הזמנה',
  SPECIAL_INSTRUCTIONS: 'פרטים נוספים על ההזמנה',
  STEP_OF_3: 'שלב {X} מ-3',
  SUBMIT: 'להגיש',
  TERMS_AGREED_LINK: 'תקנון',
  TERMS_AGREED_TEXT: 'קראתי ומאשר',
  THIS_WEBSITE_USES_COOKIES: 'אתר זה משתמש בקובצי Cookie',
  THANK_YOU: 'תודה!',
  THE_YEAR_OF_DEATH_LATER: 'תאריך הפטירה חייב להיות מאוחר מתאריך הלידה',
  TOTAL: "סה''כ",
  TOTAL_AMOUNT_INCORRECT: 'הסכום הכולל של השירותים שגוי',
  UNKNOWN: 'לא ידוע',
  WE_WILL_CONTACT_YOU_SHORTLY: 'אנו ניצור איתך קשר בהקדם!',
  WEBSITE: 'אתר החברה',
  YEAR: 'שנה',
  YEAR_LATER: 'שנים של חיים לא יכולות להיות בעתיד',
  YEAR_OF_BIRTH: 'שנת לידה',
  YEAR_OF_DEATH: 'שנת פטירה',
  YEARS_OF_LIFE: 'שנות חיים',
  YES: 'כן',
  YOUR_MESSAGE: 'ההודעה שלך',
  YOUR_NAME: 'השם שלך',
};
